import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import ErrorBoundary from "../../../../ErrorBoundary";
import { Tooltip } from "antd";
import HighCharts from "../../../utils/charts/HighCharts";
import DateAggregation from "../../../layout2/sectionInsight/Widget/WidgetHeader/DateAggregation";
import NoGraphData from "../../../workspace/DisplayChart/NoGraphData";
import isEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import PostCard from "../../../WidgetMaker/PostCard";

const TwitterTrendsTagCloud = ({ currentActiveTab }) => {
  const Wordcloud = React.lazy(() => import("../DeepDivetab/Wordcloud/index"));
  const isDetailedInsightVisible = useSelector(
    (state) => state.DeepDive.isDetailedInsightVisible
  ); //deep dive modal state
  const deepDiveTab = isDetailedInsightVisible?.key;
  const screen = useSelector((state) => state?.Screens?.screen);
  //console.log("screen", screen);
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  //console.log("deepdiveObject", deepdive_object);
  const twitterTrendsData = useSelector(
    (state) => state?.Screens?.screen?.deep_dive?.twitter_trend
  );
  const trendlineResponse = useSelector(
    (state) =>
      state?.Screens?.screen?.deep_dive?.twitter_trend?.trendlineMentions
  );
  const TwitterTagCloudData = twitterTrendsData?.wordcloudMentions?.tagcloud;
  const twitterMentionsData = twitterTrendsData?.wordcloudMentions?.mentions;

  const headerRef = useRef(null);
  const [refUpdated, setRefUpdated] = useState(false);
  //const [setRefOfSlider, refOfSlider] = useHookWithRefCallback();
  // callback function got called when reference of slider is loaded
  const measuredHeaderRef = useCallback((node) => {
    if (node !== null) {
      headerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);
  // widget container ref
  const widgetContainerRef = useRef(null);
  // callback function got called when reference of widgetContainer is loaded
  const measuredWidgetContainerRef = useCallback((node) => {
    if (node !== null) {
      widgetContainerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);
  const [widgetContainerStyle, setWidgetContainerStyle] = useState(
    widgetContainerRef?.current
      ? {
          width: "100%",
          height: "450px",
        }
      : null
  );

  const updateSize = () => {
    if (widgetContainerRef?.current) {
      setWidgetContainerStyle({
        width: "100%",
        height:
          widgetContainerRef?.current?.offsetHeight &&
          widgetContainerRef?.current?.offsetHeight - 33,
      });
      setRefUpdated(!refUpdated);
    }
  };
  useEffect(() => {
    updateSize();
  }, [
    headerRef?.current,
    headerRef?.current?.clientHeight,
    widgetContainerRef?.current,
    widgetContainerRef?.current?.clientHeight,
    widgetContainerRef?.current?.offsetHeight,
  ]);
  useEffect(() => {
    let refershHandler = setTimeout(() => {
      if (currentActiveTab == "1") {
        updateSize();
      }
    }, [200]);
    return () => {
      clearTimeout(refershHandler);
    };
  }, [currentActiveTab]);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100%",
          width: "100%",
        }}
      >
        <ErrorBoundary chart={true}>
          {" "}
          <div
            style={{
              width: "70%",
              height: "70vh",
            }}
            ref={measuredWidgetContainerRef}
          >
            {TwitterTagCloudData ? (
              <HighCharts
                id={"wordCloud"}
                deepDive={true}
                single={TwitterTagCloudData}
                xaxis={"Keyword"}
                yaxis={"Count"}
                style={widgetContainerStyle}
                type="wordcloud"
              />
            ) : (
              <div className="h-100 text-center d-flex">
                {" "}
                <div className="lds-ring m-auto">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>{" "}
              </div>
            )}
          </div>
        </ErrorBoundary>

        <div
          className="left-border custom_scroll"
          style={{
            maxHeight: "70rem",
            width: "30%",
            height: "70vh",
            overflow: "scroll",
            overflowX: "hidden",
          }}
        >
          <ErrorBoundary chart={true}>
            {" "}
            {twitterMentionsData ? (
              <PostCard
                isTwitterTrendScreen={true}
                isCommandCenterScreen={true}
                data={twitterMentionsData}
                highlightWord={deepdive_object?.deepdive_on?.x_axis?.value?.toLocaleString()}
              />
            ) : (
              <div className="h-100 text-center d-flex">
                {" "}
                <div className="lds-ring m-auto">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>{" "}
              </div>
              // add post card loader her
            )}
          </ErrorBoundary>
        </div>
      </div>
    </>
  );
};

export default React.memo(TwitterTrendsTagCloud, isEqual);
